import { ModuleWithProviders, NgModule } from '@angular/core';
import { REPORTING_ROUTE_PROVIDERS } from './providers/route.provider';

@NgModule()
export class ReportingConfigModule {
  static forRoot(): ModuleWithProviders<ReportingConfigModule> {
    return {
      ngModule: ReportingConfigModule,
      providers: [REPORTING_ROUTE_PROVIDERS],
    };
  }
}
